export const actions = {
  set_state: 'credentials/set_state',
  credential_sign_in: 'credentials/credential_sign_in',
  verify_email: 'credentials/verify_email',
  credential_register: 'credentials/credential_register',
  credential_forgot_password: 'credentials/credential_forgot_password',
  credential_reset_password: 'credentials/credential_reset_password'
}
